import { useTranslation } from 'react-i18next';

import {
    Anchor,
    Body1,
    Button,
    Modal,
    Stack,
} from '@myphx-engineering/phx-design-system';
import { useDisclosure } from '@myphx-engineering/phx-design-system/hooks';

type PharmacyChangeLinkProps = {
    prescriberOrderId?: string;
};

export const PharmacyChangeLink = ({
    prescriberOrderId,
}: PharmacyChangeLinkProps) => {
    const [opened, { toggle }] = useDisclosure(false);
    const { t } = useTranslation();

    const handleChooseDifferentPharmacy = () => {
        if (!prescriberOrderId) {
            // oxlint-disable-next-line no-console
            console.error(
                'No prescriberOrderId available for simplified provider selection'
            );
            return;
        }

        const simplifiedProvidersUrl = `${import.meta.env.VITE_MYPHX_UNAUTH_URL}/direct/${prescriberOrderId}/providers`;

        window.location.replace(new URL(simplifiedProvidersUrl));
    };

    return (
        <>
            <Anchor
                textAlign="center"
                textDecoration="underline"
                onClick={toggle}
            >
                {t('signUpPage.lilly.pharmacyChange.link')}
            </Anchor>

            <Modal
                opened={opened}
                title={t('signUpPage.lilly.pharmacyChange.modal.title')}
                onClose={toggle}
                size="lg"
            >
                <Stack gap="lg">
                    <Stack gap="xs">
                        <Body1>
                            {t('signUpPage.lilly.pharmacyChange.modal.body1')}
                        </Body1>

                        <Body1 bold>
                            {t('signUpPage.lilly.pharmacyChange.modal.body2')}
                        </Body1>

                        <Body1>
                            {t('signUpPage.lilly.pharmacyChange.modal.body3')}
                        </Body1>
                    </Stack>
                    <Button size="lg" onClick={toggle}>
                        {t(
                            'signUpPage.lilly.pharmacyChange.modal.button.primary'
                        )}
                    </Button>
                    <Button
                        size="lg"
                        variant="outline"
                        onClick={handleChooseDifferentPharmacy}
                    >
                        {t(
                            'signUpPage.lilly.pharmacyChange.modal.button.secondary'
                        )}
                    </Button>
                </Stack>
            </Modal>
        </>
    );
};
